module.exports = __webpack_public_path__ + "img/blue.f1a104a6.svg";